import { render, staticRenderFns } from "./TemplateLayer.vue?vue&type=template&id=3d89fac0"
import script from "./TemplateLayer.vue?vue&type=script&lang=js"
export * from "./TemplateLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d89fac0')) {
      api.createRecord('3d89fac0', component.options)
    } else {
      api.reload('3d89fac0', component.options)
    }
    module.hot.accept("./TemplateLayer.vue?vue&type=template&id=3d89fac0", function () {
      api.rerender('3d89fac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/viewer/TemplateLayer.vue"
export default component.exports